module.exports = __webpack_public_path__ + "88394d3926d0e8ee0546de8b8f0c73b4.png";